// 定数定義
// localStorage key
const KEY_LAST_CART_DATA = "MS_APP_LAST_CART_DATA";
const KEY_CHECKEDOUT_LINE_ITEMS = "MS_APP_CHECKEDOUT_LINE_ITEMS";

// カートデータ管理用変数
let currentCartData;
let lastCartData;

// カート中身数
let cartCountElem = document.querySelector('.cart-count-bubble');
if (cartCountElem) {
  cartCountElem.style.display = "none";
} else {
  // for MS-YEG theme..
  // insert HTML DOM to prevent error..
  var htmlString = `
  <div class="cart-count-bubble">
      <span aria-hidden="true">0</span>
    <span class="visually-hidden">0</span>
  </div>
`;

  // Create a DOM element from the HTML string
  var parser = new DOMParser();
  var doc = parser.parseFromString(htmlString, 'text/html');
  var newElement = doc.body.firstChild; // Get the div element
  
  document.querySelector('#cart-icon-bubble span').after(newElement);
  cartCountElem = document.querySelector('.cart-count-bubble');
  cartCountElem.style.display = "none";
}

// カートデータ取得 & 復元処理
fetch("/cart.js")
  .then(response => response.json())
  .then(cart => {
    currentCartData = cart;
    console.log("現在のカートデータ:", currentCartData);
    
    checkAndRestoreCart();
  })
  .catch(error => {
    console.error("カート情報の取得に失敗しました:", error);
    console.log("ページを再読み込みします。");
    window.location.reload();
  });


/**
 * カートの復元チェックと実行
 */
function checkAndRestoreCart() {
  getLastCartData();
  const checkedOutItems = getCheckedOutItems();

  let isNotYetCheckedOut = false;
  if (checkedOutItems && checkedOutItems.length) {
    // localStorageにcheckedOutItemsがあるが、カート中身が同じ状態 の場合
    isNotYetCheckedOut = currentCartData.items.some(obj => obj.variant_id === checkedOutItems[0].variantId); 
  }
  if (isNotYetCheckedOut) {
      console.log("checkoutUrl生成するも、チェックアウト完了せず..");
      updateCurrentCartDataOnLS();
      return;
  }
  
  
  // カートトークンが変更された場合の処理
  if (currentCartData.token !== lastCartData.token) {
    console.log("カートトークンが変更されました...新しいカートを検出");

    if (!checkedOutItems) {
      console.log("チェックアウトの形跡はなし..");
      updateCurrentCartDataOnLS();
      return;
    }

    // カート中身がある場合は、復元処理を行わず終了 = localStorage削除
    if (currentCartData.items.length > 0) { 
      console.log("カート中身がある場合は、復元処理を行わず終了 = localStorage削除")
      // delete
      localStorage.removeItem(KEY_CHECKEDOUT_LINE_ITEMS);
      console.log(`localStorage key ${KEY_CHECKEDOUT_LINE_ITEMS} を削除しました`);
        
      updateCurrentCartDataOnLS();
      return;
    }
    
    // restore to cart..
    const itemsToRestore = filterRestorableItems(checkedOutItems);
    if (itemsToRestore.length > 0) {
      restoreCartItems(itemsToRestore);
    } else {
      console.log("復元するデータがなし..");
      updateCurrentCartDataOnLS();
    }
  } else {
      updateCurrentCartDataOnLS();
  }
  
  // document.getElementById("loading").style.display = "none";
  // $("#loading").fadeOut(180);
}

function getLastCartData() {
  const lastCartDataStr = localStorage.getItem(KEY_LAST_CART_DATA);
  if (!lastCartDataStr) {
    updateCurrentCartDataOnLS();
    return;
  }

  lastCartData = JSON.parse(lastCartDataStr);
  console.log("最後のcheckoutUrl生成時のカートデータ:", lastCartData);
  if (!lastCartData) {
    updateCurrentCartDataOnLS();
  }
}

function updateCurrentCartDataOnLS() {
    // save current cart data
    localStorage.setItem(KEY_LAST_CART_DATA, JSON.stringify(currentCartData));
    if (currentCartData.item_count > 0) {
      cartCountElem.style.display = "inline";
    }
  
    showCart();
    const loading = document.getElementById("loading");
    fadeOut(loading, 180);
}

/**
 * チェックアウト済みアイテムを取得
 */function getCheckedOutItems() {
  const stored = localStorage.getItem(KEY_CHECKEDOUT_LINE_ITEMS);
  if (!stored) return null;

  const checkedOutItems = JSON.parse(stored);
  console.log("チェックアウト済みアイテム:", checkedOutItems);
  return checkedOutItems;
}

/**
 * 復元可能なアイテムをフィルタリング
 */
function filterRestorableItems(checkedOutItems) {
  console.log("復元可能なアイテムをフィルタリング");
  console.log("lastCartData.items:", lastCartData.items);
  console.log("checkedOutItems:", checkedOutItems);
  return lastCartData.items
    .filter(item => !isCheckedOutItem(item, checkedOutItems))
    .map(item => ({
      id: item.id,
      quantity: item.quantity,
      attributes: item.properties
    }));
}

/**
 * チェックアウト済みアイテムか判定
 */
function isCheckedOutItem(item, checkedOutItems) {
  const checkedOutVariantIds = checkedOutItems.map(n => n.variantId);
  return checkedOutVariantIds.includes(item.id);
}

/**
 * カートアイテムを復元
 */
async function restoreCartItems(items) {
  try {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items })
    });

    // ここで復元が反映されたか確認
    let restored = false;
    for (let i = 0; i < 20; i++) { // 最大10回リトライ
      const res = await fetch("/cart.js");
      const cart = await res.json();
      console.log("restored cart:", cart);
      // itemsがすべてcart.itemsに含まれているか確認
      restored = items.every(item =>
        cart.items.some(cartItem => cartItem.id === item.id && cartItem.quantity === item.quantity)
      );
      if (restored) {
        // set
        currentCartData = cart;
        
        var elms = cartCountElem.querySelectorAll('span');
        var count = currentCartData.item_count;
        if (count > 0) {
          elms[0].innerText = count;
          elms[1].innerText = count + "個のアイテム";
          cartCountElem.style.display = "inline";
        }
        
        console.log("カートアイテムの復元処理を完了しました。念の為、カート空になる現象がないか 再確認します");
        
        // カート復元 再度確認を毎1秒ごとに最大10回実行
        let checkCount = 0;
        const checkInterval = setInterval(() => {
          checkCount++;
          console.log(`カート復元確認 ${checkCount}/10回目`);
          
          fetch("/cart.js")
            .then(response => response.json())
            .then(cart => { 
              console.log("cart:", cart) 
              if (cart.item_count === 0) {
                console.log("カート復元が完了しましたが、カートが空になっています。不具合の可能性があります。画面再読み込みして、再実行します。");
                window.location.reload();
              } else {
                console.log("カート中身 空でないOK:", cart);
                
                // delete
                localStorage.removeItem(KEY_CHECKEDOUT_LINE_ITEMS);
                console.log(`localStorage key ${KEY_CHECKEDOUT_LINE_ITEMS} を削除しました`);
              }
            })
            .catch(error => {
              console.error("カート確認エラー:", error);
            });
            
          // 最大10回で停止
          if (checkCount >= 10) {
            clearInterval(checkInterval);
            console.log("カート復元確認を10回実行しました");
          }
        }, 1000); // 1秒間隔
        
        // カート画面かどうかで処理を分岐
        const isCartPage = window.location.pathname === "/cart";
        if (!isCartPage && cartCountElem && typeof currentCartData === 'object' && typeof currentCartData.item_count === 'number') {
          // カート画面以外：カート中身数を更新するだけ（再読み込みしない）
          // ここで必要な処理があれば記述
        } else {
          // カート画面：ページをリロードして最新状態を反映
          console.log("ページを再読み込みします。");
          window.location.reload();
        }
        break;
      }
      
      if (i === 19) {
        console.log("カートに反映に時間が掛かっています。念の為、画面を再読み込み時に、再度実行します。");
        window.location.reload();
        break;
      }
      await new Promise(r => setTimeout(r, 400)); // 400ms待つ
    }
  } catch (error) {
    console.error("カートアイテムの復元に失敗しました:", error);
  }
}

/**
 * カート中身 表示
 */
function showCart() {
    document.querySelectorAll("cart-items form").forEach(elm => {
      elm.style.visibility = null;
    });
  if (document.querySelector("cart-items")) {
    document.querySelector("cart-items").style.visibility = null; 
  }
}

function updateCurrentCartData() {
  return fetch("/cart.js")
    .then(response => response.json())
    .then(cart => {
      currentCartData = cart;
    });
}

function fadeOut(element, duration = 180) {
  if (!element) return;
  element.style.transition = `opacity ${duration}ms`;
  element.style.opacity = 0;
  setTimeout(() => {
    element.style.display = "none";
  }, duration);
}